import {HttpErrorResponse} from '@angular/common/http';

/**
 * Why content could not be loaded, as a screen shows it (`app-error-state`): `unavailable` can be retried, the two others
 * cannot. The engine's own statuses (KAB-2483): 403 refused, 404 gone, 5xx or no answer to retry.
 */
export type LoadError = 'unavailable' | 'forbidden' | 'notFound';

export function toLoadError(error: unknown): LoadError {
	if (error instanceof HttpErrorResponse && error.status === 403) {
		return 'forbidden';
	}
	if (error instanceof HttpErrorResponse && error.status === 404) {
		return 'notFound';
	}
	return 'unavailable';
}
